export const AuthSourceEnum = {
  READING_CRITTERS: 'readingcritters',
} as const;
